import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  RETURNS_SETTINGS_TAB_QUERY_PARAM,
  type ReturnsSettingsTab,
} from "@redotech/redo-settings-common/flat-team-settings/returns/returns-settings-tab";
import { RETURNS_CONSOLIDATED_SETTINGS_PATH } from "@redotech/redo-settings-common/flat-team-settings/returns/settings-paths";
import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";

/** An old returns settings page's URL lands on the tab that replaced it, keeping highlight params. */
export const ReturnsSettingsTabRedirect = memo(
  function ReturnsSettingsTabRedirect({ tab }: { tab: ReturnsSettingsTab }) {
    const routes = useRequiredContext(MerchantRoutesContext);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    params.set(RETURNS_SETTINGS_TAB_QUERY_PARAM, tab);
    return (
      <Navigate
        replace
        to={routes.getSettingsSubRoute(
          `${RETURNS_CONSOLIDATED_SETTINGS_PATH}?${params}`,
        )}
      />
    );
  },
);
